import React from 'react';
import { missingTaxNote, taxRows } from '../quoteFinancialPresentation';
import { formatQuoteDecimal } from './QuoteDecimalInput';
import './QuoteTaxBreakdown.css';

export default function QuoteTaxBreakdown({ source, formatMoney }) {
  const rows = taxRows(source);
  return <div className="quote-sales-sheet__table-wrap quote-tax-breakdown">
    {rows.length ? <table aria-label="Ventilation de TVA">
      <thead><tr><th>Taux</th><th>HT</th><th>TVA</th><th>TTC</th></tr></thead>
      <tbody>{rows.map((row) => <tr key={row.rate}>
        <td>{formatQuoteDecimal(Number(row.rate) * 100, 2)} %</td><td>{formatMoney(row.base_ht)}</td>
        <td>{formatMoney(row.tax_amount)}</td><td>{formatMoney(row.total_ttc)}</td>
      </tr>)}</tbody>
    </table> : <p className="quote-detail-empty">{missingTaxNote}</p>}
  </div>;
}
